import { render, staticRenderFns } from "./BookingConfirmationModal.vue?vue&type=template&id=65c89da0"
import script from "./BookingConfirmationModal.vue?vue&type=script&lang=ts"
export * from "./BookingConfirmationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports